import './style.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import {Icon, Style, Fill, Stroke, Text} from 'ol/style'
import {Vector as VectorSource} from 'ol/source'
import {Vector as VectorLayer} from 'ol/layer'
import {fromLonLat} from 'ol/proj';
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point';
import LineString from 'ol/geom/LineString'
import Control from 'ol/control/Control'

import santaPng from './assets/santa.png'
import presentPng from './assets/present.png'

// Import header images so Vite includes them in the build, do not remove
import headerDesktopLions from './assets/santatracker-header-desktop-lions.png'
import headerMobileLions from './assets/santatracker-header-mobile-lions.png'
import headerDesktopRotary from './assets/santatracker-header-desktop-rotary.png'
import headerMobileRotary from './assets/santatracker-header-mobile-rotary.png'

const apiUrl = 'https://api.lionssantatracker.net';

let firstLoad = true;
let updateInterval = null;

const NORTH_POLE_LOCATION = {
  latitude: 79.9385,
  longitude: 20.1661,
  zoom: 6
}

const ZOOM_LEVEL = 16;

// Update map size on window resize
window.addEventListener('resize', function() {
  if (map) {
    setTimeout(function() {
      map.updateSize();
    }, 250);
  }
});

// Handle visibility change for battery optimization
document.addEventListener('visibilitychange', function() {
  if (document.hidden) {
    clearInterval(updateInterval);
  } else {
    startUpdates();
  }
});

// Trail styling
const trailStyle = new Style({
  image: new Icon({
    src: presentPng,
    scale: [0.02, 0.02]
  }),
});

const trailSource = new VectorSource({});
const trailLayer = new VectorLayer({
  source: trailSource,
  style: new Style({
    fill: new Fill({ color: '#dc2626' }),
    stroke: new Stroke({ color: '#dc2626', width: 2 })
  })
});

// Santa styling
const santaStyle = new Style({
  image: new Icon({
    src: santaPng,
    scale: [0.08, 0.08]
  }),
});

const santaSource = new VectorSource({});
const santaLayer = new VectorLayer({
  source: santaSource,
});

// Create custom "Center on Santa" button control
class CenterOnSantaControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.title = 'Center on Santa';
    button.className = 'center-santa-btn';
    
    // Create image element for Santa icon
    const img = document.createElement('img');
    img.src = santaPng;
    img.alt = 'Santa';
    img.className = 'santa-icon';
    button.appendChild(img);

    const element = document.createElement('div');
    element.className = 'center-santa-control ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener('click', this.handleCenterOnSanta.bind(this), false);
  }

  handleCenterOnSanta() {
    const features = santaSource.getFeatures();
    if (features.length > 0) {
      const santaFeature = features[0];
      const geometry = santaFeature.getGeometry();
      const coordinates = geometry.getCoordinates();
      
      map.getView().animate({
        center: coordinates,
        duration: 500,
        zoom: atNorthPole ? 4 : ZOOM_LEVEL
      });
    }
  }
}

// Initialize map
const map = new Map({
  target: 'map',
  layers: [
    new TileLayer({
      source: new OSM()
    }),
    trailLayer,
    santaLayer
  ],
  view: new View({
    center: fromLonLat([NORTH_POLE_LOCATION.longitude, NORTH_POLE_LOCATION.latitude]),
    zoom: ZOOM_LEVEL
  })
});

// Add the Center on Santa control
map.addControl(new CenterOnSantaControl());

// Ensure map is properly sized after initialization
setTimeout(() => {
  map.updateSize();
}, 100);

let atNorthPole = false;

setLionsSpecific();

function displayPositions(positions) {
  santaSource.clear();
  trailSource.clear();

  const trail = positions.slice(1);
  const trailPositions = trail.map(pos => fromLonLat([pos.longitude, pos.latitude]))
  const santaPosition = fromLonLat([positions[0].longitude, positions[0].latitude]);

  const santaFeature = new Feature({
    geometry: new Point(santaPosition),
    name: 'Santa',
  });
  santaFeature.setStyle(santaStyle);

  santaSource.addFeature(santaFeature);
  
  if (positions[0].zoom && !atNorthPole) {
    map.getView().setZoom(4);
    map.getView().setCenter(santaPosition);
    atNorthPole = true;
  }
  else if (!positions[0].zoom && atNorthPole) {
    atNorthPole = false;
    map.getView().setZoom(ZOOM_LEVEL);
    map.getView().setCenter(santaPosition);
  }

  if (firstLoad) {
    map.getView().setCenter(santaPosition);
    firstLoad = false;
  }

  if (!atNorthPole) {
    let lastPosition = null;
    trailPositions.forEach(position => {
      const trailFeature = new Feature({
        geometry: new Point(position),
      });
      trailFeature.setStyle(trailStyle);
      trailSource.addFeature(trailFeature);

      if (lastPosition != null) {
        const trailLine = new Feature({
          geometry: new LineString([lastPosition, position])
        });
        trailSource.addFeature(trailLine);
      }
      lastPosition = position;
    });
    
    if (trailPositions.length > 0) {
      const trailLine = new Feature({
        geometry: new LineString([trailPositions[0], santaPosition])
      });
      trailSource.addFeature(trailLine);
    }
  }
}

function getPositions() {
  const url = apiUrl + "/getdevicepositions";
  const headers = new Headers();
  
  fetch(url, { headers })
    .then(res => res.json())
    .then(data => {
      if (data.Results.length === 0) {
        displayPositions([NORTH_POLE_LOCATION]);
        document.getElementById("info-date").textContent = 'Santa is currently picking up more presents, come back soon!';
      } else {
        const date = new Date(data.Results[0].infodate);
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        document.getElementById("info-date").textContent = `Last updated: ${hours}:${minutes}. Santa may be slightly ahead of his position shown on the map`;
        displayPositions(data.Results);
      }
    })
    .catch(err => {
      console.error('Error fetching positions:', err);
      // Default to North Pole when API is unavailable
      displayPositions([NORTH_POLE_LOCATION]);
      document.getElementById("info-date").textContent = 'Santa is currently picking up more presents, come back soon!';
    });
}

function setLionsSpecific() {
  var domain = /:\/\/([^\/]+)/.exec(window.location.href)[1].toLowerCase();

  // Helper references (may be null in some layouts)
  var routeEl = document.getElementById("route-link");
  var lionsEl = document.getElementById("lions-link");
  var brandingTitleEl = document.getElementById("branding-title-link");
  var pageTitleEl = document.getElementById("page-title");
  var headerDesktop = document.getElementById("header-desktop");
  var headerMobile = document.getElementById("header-mobile");

  if(domain.includes("test") || domain.includes("local") || domain.includes("wetherby")) {
    if (routeEl) { routeEl.href = `https://www.wetherbylions.org/_files/ugd/c5f434_5f87b8e00f164d7db22da09ac34756c9.pdf`; routeEl.style.display = ''; }
    if (brandingTitleEl) { brandingTitleEl.href = 'https://www.wetherbylions.org/'; brandingTitleEl.textContent = 'Wetherby Lions'; }
    if( pageTitleEl) { pageTitleEl.textContent = 'Wetherby Lions Santa Tracker'; }
  }
  else if(domain.includes("swanwick")){
    if (routeEl) { routeEl.href = `https://www.swanwicklions.org.uk/calender2005.html`; routeEl.style.display = ''; }
    if (brandingTitleEl) { brandingTitleEl.href = 'https://www.swanwicklions.org.uk/'; brandingTitleEl.textContent = 'Swanwick Lions'; }
    if( pageTitleEl) { pageTitleEl.textContent = 'Swanwick Lions Santa Tracker'; }
  }
  else if(domain.includes("easingwold")){
    if (routeEl) { routeEl.href = `https://www.e-clubhouse.org/sites/easingwold/page-9.php`; routeEl.style.display = ''; }
    if (brandingTitleEl) { brandingTitleEl.href = 'https://www.e-clubhouse.org/sites/easingwold/index.php'; brandingTitleEl.textContent = 'Easingwold Lions'; }
    if( pageTitleEl) { pageTitleEl.textContent = 'Easingwold District Lions Santa Tracker'; }
  }
  else if(domain.includes("brampton")){
    if (routeEl) { routeEl.href = `https://rotary-ribi.org/clubs/page.php?PgID=988341&ClubID=1497`; routeEl.style.display = ''; }
    if (brandingTitleEl) { brandingTitleEl.href = 'https://rotary-ribi.org/clubs/homepage.php?ClubID=1497'; brandingTitleEl.textContent = 'Brampton & Longtown Rotary'; }
    if( pageTitleEl) { pageTitleEl.textContent = 'Brampton & Longtown Rotary Santa Tracker'; }
    // Set Rotary header images using imported URLs
    if (headerDesktop) { headerDesktop.srcset = headerDesktopRotary; }
    if (headerMobile) { headerMobile.src = headerMobileRotary; }
  }
  else if(domain.includes("tenterden")){
    if (routeEl) { routeEl.href = `https://tenterdenlionsclub.co.uk/christmas-float-2025/`; routeEl.style.display = ''; }
    if (brandingTitleEl) { brandingTitleEl.href = 'https://tenterdenlionsclub.co.uk'; brandingTitleEl.textContent = 'Tenterden Lions Club'; }
    if( pageTitleEl) { pageTitleEl.textContent = 'Tenterden Lions Club Santa Tracker'; }
  }
}

function startUpdates() {
  if (updateInterval) {
    clearInterval(updateInterval);
  }
  getPositions();
  updateInterval = setInterval(getPositions, 15000);
}

// Initialize
atNorthPole = false;
displayPositions([NORTH_POLE_LOCATION]);

// Uncomment to enable live updates:
//startUpdates();
document.getElementById("info-date").textContent = 'Santa is back at the North Pole until next Christmas';